import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H5, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

interface Props {
  id?: string
}

const TooltipText: FC<Props> = ({id}) => {
  return (
    <Flex
      id={id}
      direction="column"
      padding={2}>
      <H5 marginBottom={1}>
        <FormattedMessage id="platform.earnPoints.tooltipText.title" />
      </H5>
      <Body>
        <FormattedMessage id="platform.earnPoints.tooltipText.body" />
      </Body>
    </Flex>
  )
}

export default TooltipText
